/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StrapiBlockFromJSON, StrapiBlockToJSON, } from './StrapiBlock';
/**
 * Check if a given object implements the OnSubmitComponent interface.
 */
export function instanceOfOnSubmitComponent(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('useRedirect' in value) || value['useRedirect'] === undefined)
        return false;
    return true;
}
export function OnSubmitComponentFromJSON(json) {
    return OnSubmitComponentFromJSONTyped(json, false);
}
export function OnSubmitComponentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'useRedirect': json['useRedirect'],
        'text': json['text'] == null ? undefined : (json['text'].map(StrapiBlockFromJSON)),
        'url': json['url'] == null ? undefined : json['url'],
    };
}
export function OnSubmitComponentToJSON(json) {
    return OnSubmitComponentToJSONTyped(json, false);
}
export function OnSubmitComponentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'useRedirect': value['useRedirect'],
        'text': value['text'] == null ? undefined : (value['text'].map(StrapiBlockToJSON)),
        'url': value['url'],
    };
}
